var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlacedProcess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3043 1.00195H4C2.34315 1.00195 1 2.3451 1 4.00195V38.002C1 39.6588 2.34315 41.002 4 41.002H29.3043C30.9612 41.002 32.3043 39.6588 32.3043 38.002V28.828V4.00195C32.3043 2.3451 30.9612 1.00195 29.3043 1.00195Z",
    fill: "#FDE8F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3043 32.9463H1V38.0018C1 39.6587 2.34315 41.0018 4 41.0018H29.3043C30.9612 41.0018 32.3043 39.6587 32.3043 38.0018V32.9463Z",
    fill: "#EC187B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1289 29.2665L20.9985 25.7883L35.7811 11.4404L38.8246 14.4839L37.5202 15.751L23.6072 29.2665H20.1289Z",
    fill: "#FDE8F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5202 15.751L23.6072 29.2665H20.1289L20.9985 25.7883L35.7811 11.4404L38.8246 14.4839L37.5202 15.751ZM37.5202 15.751L38.8246 17.0926L34.9115 21.0056",
    stroke: "#EC187B",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5203 29.7021H7.95508",
    stroke: "#EC187B",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5203 22.7363H7.95508",
    stroke: "#EC187B",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8681 15.7803H7.95508",
    stroke: "#EC187B",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3043 10.5672V4.00195C32.3043 2.3451 30.9612 1.00195 29.3043 1.00195H4C2.34315 1.00195 1 2.3451 1 4.00195V38.002C1 39.6588 2.34315 41.002 4 41.002H29.3043C30.9612 41.002 32.3043 39.6588 32.3043 38.002V28.828",
    stroke: "#EC187B",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlacedProcess);
export default __webpack_public_path__ + "static/media/placed_process.71d64a55eb9710babbe5d147652108a7.svg";
export { ForwardRef as ReactComponent };